import { render, staticRenderFns } from "./CalendarioLaboralEmpleados.vue?vue&type=template&id=145f916d&scoped=true&"
import script from "./CalendarioLaboralEmpleados.vue?vue&type=script&lang=ts&"
export * from "./CalendarioLaboralEmpleados.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarioLaboralEmpleados.vue?vue&type=style&index=0&id=145f916d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145f916d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
